export default __webpack_public_path__ + "static/media/goldbar_2.99f52a2b.jpg";